
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.091-.45-.254-.611zm-1.755.69h-6.325V2.978l6.325 6.324zM6.009 31.27V2.73h13.648v7.438c0 .478.387.865.865.865h7.469V31.27H6.009z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm0 3.901h14.5a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm2.209 8.576a1.82 1.82 0 00.342-1.101c0-.663-.205-1.168-.616-1.514-.41-.347-.996-.52-1.758-.52H7.688v6.763h.897v-2.736h1.589l1.468 2.736h.957v-.056l-1.589-2.871c.405-.154.722-.388.949-.701zm-2.005.163h-1.37v-2.569H9.95c.471.003.831.116 1.08.34.249.223.374.544.374.963 0 .385-.131.692-.392.922-.262.229-.614.344-1.058.344zm5.524-3.299l-2.583 6.764h.92l.636-1.77h2.834l.645 1.77h.916l-2.588-6.764h-.78zm-.757 4.265l1.148-3.163 1.152 3.163h-2.3zm10.219.362l-.143.911-.186-.817-1.305-4.72h-.754l-1.337 4.72-.191.803-.13-.892-1.068-4.631h-.892l1.635 6.763h.813l1.444-4.929.108-.515.106.515 1.394 4.929h.813l1.64-6.763h-.897"}})])])
          )
        }
      }
    